import React from 'react';
import {
  Route,
  createRoutesFromElements,
} from 'react-router-dom';
import Home from '../views/Home';
import Course from '../views/Course';
import Lesson from '../views/Lesson';
import SignUp from '../views/SignUp';
import SignIn from '../views/SignIn';
import Contact from '../views/Contact';
import ForgotPassword from '../views/ForgotPassword';
import ResetPassword from '../views/ResetPassword';
import PrivacyPolicy from '../views/PrivacyPolicy';
import TermsConditions from '../views/TermsConditions';
import AdminRedirect from "./AdminRedirect";
import AnalyticsLayout from "./AnalyticsLayout";

const routeElements = (
  <Route path="/">
    <Route path="/admin">
      <Route index element={<AdminRedirect />} />
      <Route path=":seg1" element={<AdminRedirect />} />
    </Route>
    <Route
      path="privacy"
      element={<PrivacyPolicy />}
      handle="PrivacyPolicy"
    />
    <Route
      path="terms"
      element={<TermsConditions />}
      handle="TermsConditions"
    />
    <Route path="/:lang" element={<AnalyticsLayout />}>
      <Route index element={<Home />} handle="Home" />
      <Route
        path="privacy"
        element={<PrivacyPolicy />}
        handle="PrivacyPolicy"
      />
      <Route
        path="terms"
        element={<TermsConditions />}
        handle="TermsConditions"
      />
      <Route path="signup" element={<SignUp />} handle="SignUp" />
      <Route path="signin" element={<SignIn />} handle="SignIn" />
      <Route path="contact" element={<Contact />} handle="Contact" />
      <Route
        path="forgot-password"
        element={<ForgotPassword />}
        handle="ForgotPassword"
      />
      <Route
        path="reset-password"
        element={<ResetPassword />}
        handle="ResetPassword"
      />

      <Route path=":courseSlug">
        <Route index element={<Course />} handle="Course" />
        <Route path=":lessonSlug" element={<Lesson />} handle="Lesson" />
      </Route>
    </Route>
    <Route index element={<Home />} />
  </Route>
);

const routes = createRoutesFromElements(routeElements);
export default routes;
